import { render } from "./LogoutAction.vue?vue&type=template&id=8c81d40c"
import script from "./LogoutAction.vue?vue&type=script&lang=js"
export * from "./LogoutAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__